import { render, staticRenderFns } from "./VideoCallShop.vue?vue&type=template&id=6662d9fc&"
import script from "./VideoCallShop.vue?vue&type=script&lang=js&"
export * from "./VideoCallShop.vue?vue&type=script&lang=js&"
import style0 from "./VideoCallShop.vue?vue&type=style&index=0&id=6662d9fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports